import { useRoutes, useNavigate, useLocation } from 'react-router-dom';
import router from 'src/router';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';

import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';

import WindowEventListener from "./common/WindowEventListener";
import { GameModalProvider, useGameModal } from './contexts/GameModalContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { useEffect } from 'react';
import GameMgr from './common/GameMgr';

WindowEventListener.startListen();

// Auto scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);
  return null;
};

// Component to initialize the GameMgr references
const GameModalInitializer = () => {
  const { openGameModal } = useGameModal();
  const navigate = useNavigate();
  
  useEffect(() => {
    // Set both functions in GameMgr
    GameMgr.openGameModal = openGameModal;
    GameMgr.navigate = navigate;
    
    console.log('GameModalInitializer: Set up GameMgr functions');
    console.log('GameMgr.openGameModal available:', !!GameMgr.openGameModal);
    console.log('GameMgr.navigate available:', !!GameMgr.navigate);
    
    return () => {
      // Clear references on unmount
      GameMgr.openGameModal = null;
      GameMgr.navigate = null;
    };
  }, [openGameModal, navigate]);
  
  return null;
};

function App() {
  const content = useRoutes(router);

  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <CssBaseline />
        <link href="https://fonts.googleapis.com/css2?family=Anton+SC&display=swap" rel="stylesheet" />
        <LanguageProvider>
          <GameModalProvider>
            <ScrollToTop />
            <GameModalInitializer />
            {content}
          </GameModalProvider>
        </LanguageProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}
export default App;
